import React, { Component } from "react";
import './style.css';

export default class ShapedBox extends Component {
    render() {
        const { shape, className } = this.props;
        const { onClick } = this.props;

        return (
            <div className={`box ${shape || `square`} ${className || ''}`} onClick={onClick}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/common/ShapedBox/index.js